import { DateTime } from "luxon";

import { LISCase, LISTask, LISWork } from "pwapi";

import { getDateDiff, DateDiff } from "shared/utils/dates";

export const workProcessState = (w: LISCase["work_processes"][0]) => {
  const taskType = w.tasks?.find((t) => !t.completed_at)?.type;
  return taskType ?? "completed";
};

export const workProcessSort = (
  w1: LISCase["work_processes"][0],
  w2: LISCase["work_processes"][0]
) => {
  if (!w1.id || !w2.id) return 0;

  if (w1.order?.id && w2.order?.id) return w1.order.id - w2.order.id;
  if (!w1.order?.id && !w2.order?.id) return w1.id - w2.id;
  if (w1.order?.id && !w2.order?.id) return 1;
  if (!w1.order?.id && w2.order?.id) return -1;
  return 0;
};

export const taskLongevity = (
  task?: LISTask,
  useMinutes?: boolean
): DateDiff | null => {
  if (!task?.created_at) return null;

  const taskStartedTime = DateTime.fromISO(task.created_at);
  const taskEndTime =
    task.completed_at && task.started_at
      ? DateTime.fromISO(task.completed_at)
      : undefined;

  return getDateDiff(taskStartedTime, taskEndTime, useMinutes);
};

export const getLongestRunningTaskfromWorkProcesses = (
  workProcesses: LISWork[],
  taskType?: LISTask.type
) => {
  let processes = workProcesses.flatMap((w) => w.tasks);

  if (taskType) {
    processes = processes.filter((t) => t.type === taskType && !t.completed_at);
  }

  const longestTasks = processes
    .filter((t) => t.created_at)
    .sort((a, b) => (a.created_at! > b.created_at! ? 1 : -1));

  return longestTasks[0];
};
